import { LojistikFaturaDetay } from "./lojistik-fatura-detay";

export class LojistikFatura {
    basTar: Date;
    bitTar: Date;
    proformaNo: number;
    tasiyiciVkn: string;
    private pLojistikFaturaDetaylar: LojistikFaturaDetay[];


    constructor(obj?: any) {
        if (obj == null) {
            return;
        }
        Object.assign(this, obj);
    }

    public get lojistikFaturaDetaylar(): LojistikFaturaDetay[] {
        return this.pLojistikFaturaDetaylar;
    }

    public set lojistikFaturaDetaylar(list: LojistikFaturaDetay[]) {
        if (list != null) {
            this.pLojistikFaturaDetaylar = list.map(t => new LojistikFaturaDetay(t));
        }
    }
}
